import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_comp_set_of_books_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  set_of_books_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;

}


export class bl_fi_comp_set_of_books_link_RowClass implements bl_fi_comp_set_of_books_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  set_of_books_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;

}
